var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFullScreenBtn)?_c('el-tooltip',{attrs:{"content":_vm.isFull ? '退出全屏' : '全屏'}},[_c('i',{class:_vm.isFull ? 'el-icon-exit-fullscreen' : 'el-icon-fullscreen',on:{"click":_vm.screenChangeHandle}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }